import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MotionProvider } from "../Components/motion/space-primitives";
import Hero from "../Components/rebrand/Hero";
import Products from "../Components/rebrand/Products";
import NetworksSection from "../Components/rebrand/NetworksSection";
import Services from "../Components/rebrand/Services";
import TeamSection from "../Components/rebrand/TeamSection";
import CTA from "../Components/rebrand/CTA";
import Footer from "../Components/rebrand/Footer";
import ArticlesPreview from "../Components/rebrand/ArticlesPreview";

const Home = () => {
  const location = useLocation();

  // Landing here from another route with a section hash (e.g. /#networks from the
  // API reference pages) — scroll to that section once it is mounted.
  useEffect(() => {
    if (!location.hash) return undefined;
    const t = setTimeout(() => {
      const target = document.querySelector(location.hash);
      if (target) window.scrollTo({ top: target.offsetTop, behavior: "smooth" });
    }, 120);
    return () => clearTimeout(t);
  }, [location.hash]);

  return (
    <MotionProvider>
      <div className="flex flex-col bg-space">
        <Hero />
        <Products />
        <NetworksSection />
        <Services />
        <TeamSection />
        <ArticlesPreview />
        <CTA />
        <Footer />
      </div>
    </MotionProvider>
  );
};

export default Home;
